import { GET_BUILDINGS, SET_FETECHING, SET_BUILDING_DATA, CRUD_BUILDING, CLEAN_BUILDING_ERROR, CHANGE_SETTING_LOCAL, CHANGE_SETTING, CLEAN_BUILDING_STATE } from "./types";

const BuildingsManagementReducer = (state, action) => {
    const { type, payload } = action;
    switch (type) {
        case GET_BUILDINGS:
            return {
                ...state,
                buildingsToConfig: payload.buildingsToConfig,
                isFetching: false,
                responseBuildingService: payload.responseBuildingService
            }
        case CRUD_BUILDING:
            return {
                ...state,
                isFetching: false,
                responseBuildingService: payload.responseBuildingService
            }
        case CLEAN_BUILDING_STATE:
            return {
                ...state,
                buildingData: {
                    buildingCode: '',
                    buildingDescription: '',
                    buildingEnabled: 1,
                    openingCode: null
                },
                responseBuildingService: {
                    show: false,
                    type: '',
                    text: '',
                }
            }
        case SET_BUILDING_DATA:
            return {
                ...state,
                isFetching: false,
                buildingData: payload,
            }
        case CLEAN_BUILDING_ERROR:
            return {
                ...state,
                responseBuildingService: {
                    show: false,
                    type: '',
                    text: '',
                }
            }
        case CHANGE_SETTING:
            return {
                ...state,
                isFetching: false,
                error: payload.error
            }
        case SET_FETECHING:
            return {
                ...state,
                isFetching: payload,
            }
        case CHANGE_SETTING_LOCAL:
            return {
                ...state,
                openningsToConfig: payload,
            }
        default:
            return state;
    }
}

export default BuildingsManagementReducer;